export default "__VITE_ASSET__CYObfThl__"